module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "home_index",
    staticClass: "home_index"
  }, [_c('div', {
    staticClass: "index_box"
  }, [_c('div', {
    staticClass: "recommend_box"
  }, [_c('div', {
    staticClass: "recommend_tit"
  }, [_vm._v("推荐")]), _vm._v(" "), _vm._l((_vm.recommendData), function(recommend_tit, index) {
    return _c('div', {
      key: index,
      staticClass: "recommend_k"
    }, [_c('div', {
      staticClass: "recommend_k_tit"
    }, [_vm._v(_vm._s(index))]), _vm._v(" "), _c('van-grid', {
      attrs: {
        "border": false,
        "column-num": 4
      }
    }, _vm._l((recommend_tit), function(recommend_list, indexs) {
      return _c('van-grid-item', {
        key: indexs,
        attrs: {
          "url": recommend_list.url
        }
      }, [_c('van-image', {
        attrs: {
          "src": recommend_list.image
        }
      }), _vm._v("\n            " + _vm._s(recommend_list.title) + "\n          ")], 1)
    }), 1)], 1)
  })], 2)]), _vm._v(" "), _c('tab-bar', {
    attrs: {
      "current-index": 1
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-dd63d8d4"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/page/recommend.vue
// module id = 704
// module chunks = 1